var megaDrop = {

    init: function() {
        this.clickPattern();
        this.hoverPattern();
        this.overlay();
        document.addEventListener('click', this.closeOnClickOutside);
    },

    overlay: function() {
        var withOverlay = document.querySelector('.mega-dropdown-with-overlay');
        if (withOverlay) {
            var overlay = document.createElement('div');
            overlay.classList.add('mega-dropdown-overlay');
            document.body.appendChild(overlay);
        }
    },

    /*
     * Close dropdown on click outside
     */
    closeOnClickOutside: function(event) {
        var isClickInside = document.querySelector('.mega-dropdown').contains(event.target);

        if (!isClickInside) {
            var links = document.querySelectorAll('.mega-dropdown--click-pattern .mega-dropdown-item--show-dropdown');

            document.documentElement.classList.remove('has-visible-mega-dropdown-drop');
            for (var i = 0; i < links.length; i++) {
                links[i].classList.remove('mega-dropdown-item--show-dropdown');
            }
        }
    },

    /*
     * Adds class to open dropdown on level 1 click
     */
    clickPattern: function(event) {
        var clickLinks = document.querySelectorAll('.mega-dropdown--click-pattern .mega-dropdown-item--has-children .mega-dropdown-item__link--level-1');

        if(clickLinks && clickLinks.length) {

            var withOverlay = document.querySelector('.mega-dropdown-with-overlay');

            for (var i = 0; i < clickLinks.length; i++) {
                clickLinks[i].addEventListener('click', function(event) {
                    event.preventDefault();
                    var siblings = this.parentNode.parentNode.children;

                    if(this.parentNode.classList.contains('mega-dropdown-item--show-dropdown')) {
                        document.documentElement.classList.remove('has-visible-mega-dropdown-drop', 'has-visible-mega-dropdown-overlay');

                    } else {
                        document.documentElement.classList.add('has-visible-mega-dropdown-drop');
                        if(withOverlay) document.documentElement.classList.add('has-visible-mega-dropdown-overlay');
                    }

                    this.parentNode.classList.toggle('mega-dropdown-item--show-dropdown');

                    for (var i = 0; i < siblings.length; i++) {
                        if (siblings[i] !== event.target.parentNode) {
                            siblings[i].classList.remove('mega-dropdown-item--show-dropdown');
                        }
                    }
                });
            }
        }
    },

    /*
     * Adds class to open dropdown on level 1 hover
     * Timing Considerations for Mega menus Displayed on Hover
     * https://www.nngroup.com/articles/mega-menus-work-well/
     */
    hoverPattern: function(event) {
        var hoverLinks = document.querySelectorAll('.mega-dropdown--hover-pattern .mega-dropdown-item--has-children');

        if(hoverLinks && hoverLinks.length) {

            var withOverlay = document.querySelector('.mega-dropdown-with-overlay');

            for (var i = 0; i < hoverLinks.length; i++) {

                hoverLinks[i].addEventListener('mouseover', function(event) {
                    this.dataset.hasHover = true;
                });

                hoverLinks[i].addEventListener('mouseout', function(event) {
                     this.dataset.hasHover = false;
                });

                hoverLinks[i].addEventListener('mouseenter', function(event) {
                    var
                        siblings = this.parentNode.children,
                        self = this;

                    setTimeout(function(){
                        if(self.dataset.hasHover === 'true') {
                            self.classList.add('mega-dropdown-item--show-dropdown');
                            document.documentElement.classList.add('has-visible-mega-dropdown-drop');
                            if(withOverlay) document.documentElement.classList.add('has-visible-mega-dropdown-overlay');

                            for (var i = 0; i < siblings.length; i++) {
                                if (siblings[i] !== event.target) {
                                    siblings[i].classList.remove('mega-dropdown-item--show-dropdown');
                                }
                            }
                        }
                    }, 500);
                });

                hoverLinks[i].addEventListener('mouseleave', function(event) {
                    var self = this;

                    setTimeout(function(){
                        if(self.dataset.hasHover === 'false') {
                            self.classList.remove('mega-dropdown-item--show-dropdown');
                            document.documentElement.classList.remove('has-visible-mega-dropdown-drop', 'has-visible-mega-dropdown-overlay');
                        }
                    }, 500);
                });
            }
        }
    },

    /*
     * Toggle fullscreen menu
     */
    toggleDropdown: function() {
        document.documentElement.classList.toggle('has-visible-mega-dropdown');
    },

    /*
     * Toggle Seach
     */
    toggleSearch: function() {
        document.documentElement.classList.toggle('has-visible-search-field');

            var dropdownItems = document.querySelectorAll('.mega-dropdown-type');
            for (var i = 0; i < dropdownItems.length; i++) {
                if (dropdownItems[i] !== event.target.parentNode) {
                    dropdownItems[i].classList.remove('mega-dropdown-item--show-dropdown');
                    document.documentElement.classList.remove('has-visible-mega-dropdown-drop');
                }
            }
    },
}


megaDrop.init();

